<template>
  <div class="page_">
    <a-row>
      <div class="title_">
        <div class="cutleft_">产品计算器类别</div>
        <div class="cutoff_"></div>
      </div>
      <a-col :span="11">
        <a-select
          style="width: 200px"
          v-model="templateCode"
          placeholder="选择产品计算器类别"
        >
          <a-select-option
            v-for="item in bjqTypeList"
            :key="item.code"
            :value="item.code"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
    </a-row>

    <!-- 基本信息配置 -->
    <setting
      v-if="setShow"
      :quotationData="quotationData"
      @change="configChange"
    />

    <!-- 建工模板 -->
    <div v-if="templateCode == '001'">
      <div class="title_">
        <div class="cutleft_">新建险种：</div>
      </div>

      <div class="title_">
        <div>
          <span class="cutleft_" style="margin-right: 20px">险别</span>
          <a-select v-model="riskType" style="wisth: 80px">
            <a-select-option :value="1">主险</a-select-option>
            <a-select-option :value="2">附险</a-select-option>
          </a-select>
        </div>
        <a-button type="primary" @click="toggleRiskBg()"> 添加险种 </a-button>
      </div>

      <!-- 主附险 -->
      <div v-for="(list, index) in mainRiskList" :key="index + 'back'">
        <backstage
          v-if="list"
          :mainRiskList="mainRiskList"
          @delete="deleteOne"
          @change="riskListChange"
          :list="list"
          :listIndex="index"
        />
      </div>

      <!-- 意外住院津贴 start-->
      <div v-for="(item, index) in chooseableRisk" :key="index">
        <div class="flex_">
          <div class="flex_">
            <label>可选附加险:</label>
            <a-input
              class="wid_150"
              v-model="item.coverageName"
              placeholder="可选附加险名称"
            />
            <a-input
              class="wid_150"
              v-model="item.coverageCode"
              placeholder="可选附加险代码"
            />
            <a-icon class="icon_" type="plus" @click="addData(item, index)" />
          </div>
        </div>
        <div class="flex_" v-for="(ele, idx) in item.itemList" :key="'i' + idx">
          <a-input
            class="wid_100"
            placeholder="保额"
            v-model="ele.insuredAmount"
          />元/天 保单总保费加费<a-input
            class="wid_150"
            placeholder="保费"
            v-model="ele.premiumRate"
          />%
          <a-icon
            class="icon_"
            type="minus"
            @click="deleteData(item, index, ele, idx)"
          />
        </div>
      </div>
      <!-- 意外住院津贴 end-->

      <otherRisk
        v-if="showOtherRisk"
        :otherRiskInit="otherRiskInit"
        @change="otherRiskChange"
      />
    </div>
    <div v-else>
      <!-- 团体意外 -->
      <tuanYi :childInfo="childInfo" @change="dataChange" />
    </div>

    <div class="right_">
      <a-button type="primary" @click="handleSave">保存全部</a-button>
    </div>

    <a v-if="link" :href="link" target="_blank" style="font-size: 16px">
      报价书连接：{{ link }}
    </a>
  </div>
</template>

<script>
import backstage from "./backstage";
import setting from "./setting";
import otherRisk from "./otherRisk";
import api from "@/utils/sdApi";
import defaultOption from "./option.js";
import common from "./common";
import tuanYi from "../SDBJQ/tuanYi/tuanYi";
const bjqTypeList = [
  {
    name: "建工意外险",
    code: "001",
  },
  {
    name: "团体意外险",
    code: "002",
  },
  {
    name: "OPA（海外派遣团体意外险）",
    code: "003",
  },
];
export default {
  components: {
    backstage,
    setting,
    otherRisk,
    tuanYi,
  },
  data() {
    return {
      link: "",
      setShow: false, //展示基础设置
      showOtherRisk: false, //展示其他调整系数
      templateId: null,
      chooseableRisk: [
        {
          coverageName: "意外住院津贴",
          coverageCode: "SUBSIDY_1",
          calculateMethod: 2, //0按固定保费/1按保额费率/2按总保费费率/3按指定条目值*费率
          itemList: [
            {
              insuredAmount: "50",
              premiumRate: "10",
            },
            {
              insuredAmount: "100",
              premiumRate: "20",
            },
          ],
        },
      ],
      mainRisk: 0,
      baseData: [],
      templateCode: "001",
      riskType: 1, //险别
      bjqTypeList: bjqTypeList, //模板列表
      mainRiskList: [], //险别列表//不默认展示数据
      // mainRiskList: defaultOption.tableList,//默认展示数据
      otherRiskInfo: [], //其他调整系数, 保存时使用
      // 编辑 --->start
      quotationData: {
        labelContents: [],
        quotationInfo: {
          name: "",
        },
      },
      itemTypeList: [
        "PROJECT_TYPE",
        "PROJECT_SUBCONTRACT",
        "HURT_STANDARD",
        "CONSTRUCTION_QUALIFICATION",
      ], //通用类型itemType
      otherRiskInit: {
        areaObj: {
          itemName: "地区",
          itemType: "PROJECT_ADDRESS",
          premiumRules: [],
        },
        dateObj: {
          itemName: "工期",
          itemType: "POLICY_DAYS",
          premiumRules: [
            {
              dayMax: "2",
              dayMaxUnit: "d",
              dayMinIsContain: "0",
              dayMin: "1",
              dayMinUnit: "d",
              dayMaxIsContain: "0",
              singlePremium: "1",
              calculateMethod: 1,
            },
          ],
        },
        //<!-- i云保暂不上线TODO:测试开放 -->
        //佣金比例
        commission: {
          itemName: "佣金比例",
          itemType: "COMMISSION_RATE",
          premiumRules: [
            {
              dayMax: "2",
              dayMaxUnit: "d",
              dayMinIsContain: "0",
              dayMin: "1",
              dayMinUnit: "d",
              dayMaxIsContain: "0",
              singlePremium: "1",
              calculateMethod: 1,
            },
          ],
        },
        //<!-- i云保暂不上线TODO:测试开放 -->
        //投保份数
        countObj: {
          itemName: "投保份数",
          itemType: "INSURED_COUNT",
          premiumRules: [
            {
              calculateMethod: "1",
              singlePremium: 8,
            },
          ],
        },
        //免赔额调整系数
        deductible: {
          itemName: "免赔额系数",
          itemType: "DEDUCTIBLE_RATE",
          premiumRules: [
            {
              optinonName: "",
              optinonValue: "",
              calculateMethod: "1",
              singlePremium: "",
            },
          ],
        },
        list: [
          {
            itemName: "工程类型",
            itemType: "PROJECT_TYPE",
            premiumRules: [
              {
                optinonName: "室内装修工程（无室外）",
                singlePremium: "0.9",
                optinonValue: "1",
                calculateMethod: 1,
              },
              {
                optinonName: "幕墙等室外装修工程",
                singlePremium: "1.8",
                optinonValue: "2",
                calculateMethod: 1,
              },
              {
                optinonName: "楼宇等其他工程",
                singlePremium: "1",
                optinonValue: "4",
                calculateMethod: 1,
              },
            ],
          },
          {
            itemName: "分包类型",
            itemType: "PROJECT_SUBCONTRACT",
            premiumRules: [
              {
                optinonName: "劳务分包工程",
                singlePremium: "1.3",
                optinonValue: "1",
                calculateMethod: 1,
              },
              {
                optinonName: "非劳务分包工程",
                singlePremium: "1",
                optinonValue: "2",
                calculateMethod: 1,
              },
            ],
          },
          {
            itemName: "伤残鉴定标准",
            itemType: "HURT_STANDARD",
            premiumRules: [
              {
                optinonName: "行标",
                singlePremium: "1",
                optinonValue: "1",
                calculateMethod: 1,
              },
              {
                optinonName: "国标（十级5%起赔）",
                singlePremium: "1.1",
                optinonValue: "2",
                calculateMethod: 1,
              },
              {
                optinonName: "国标（十级10%起赔）",
                singlePremium: "1.15",
                optinonValue: "3",
                calculateMethod: 1,
              },
            ],
          },
          //<!-- i云保暂不上线TODO:测试开放 -->
          {
            itemName: "施工资质系数",
            itemType: "CONSTRUCTION_QUALIFICATION",
            premiumRules: [],
          },
        ],
      }, //其他费率调整系数初始化时接收对象
      province: [],
      tampId: "",
      uStr: "",
      // 编辑 --->end

      //以下是团意模板数据 start
      childInfo: {
        quotationPlans: [
          {
            planCode: "plan1",
            planName: "计划1",
          },
        ],
        occupationLevel: "1",
        quotationCoverageList: [], //所有类别下险别信息列表
        editObj: {
          list: [],
        },
        quotationItems: [
          {
            itemName: "保险人数",
            itemType: "INSURED_NUMS",
            premiumRules: [],
          },
        ],
      },
      myData: defaultOption.myData,
      //以上是团意模板数据 end
    };
  },
  mounted() {
    let qid = this.$route.query.id;
    console.log(this.$route, "=====>rotue");
    const route = this.$route;
    if (route.name == "Setting") {
      this.setShow = true;
      this.showOtherRisk = true;
    }
    if (route.name == "edit") {
      this.tampId = qid;
      this.queryQuotationInfo();
    }
    this.uStr = this.$route.query.uStr;
  },
  methods: {
    //团意模板start
    dataChange(data) {
      console.log("父页面", data);
      this.childInfo = data;
    },
    //团意模板end

    //建工模板start
    // 编辑部分 ---》start
    ...common,
    queryQuotationInfo() {
      let data = {
        quoteId: this.$route.query.id,
        type: "E",
      };
      return api.queryQuotationInfo(data).then((res) => {
        let msg = res.data.msg;
        this.templateCode = msg.quotationInfo.templateCode;
        let obj = this.formatLabelContents(msg);
        this.quotationData = obj;
        if (msg.quotationInfo.templateCode == "001") {
          this.tempEdit1();
        } else {
          this.tempEdit2();
        }
      });
    },
    tempEdit2() {
      this.setShow = true;
      // myData
      let data = this.quotationData;
      // let data  = this.myData
      
      this.childInfo = {
        quotationPlans: data.quotationPlans,
        occupationLevel: "1",
        quotationCoverageList: data.quotationCoverageList,
        editObj: data.quotationCoverageList[0],
        quotationItems: this.formatOccupationLevel(data),
      };
      console.log(this.childInfo,"---->00000000")
    },
    formatOccupationLevel(data) {
      //团意险配置保险人数，编辑时格式化OccupationLevel显示数据
      let list = [
        {
          itemName: "保险人数",
          itemType: "INSURED_NUMS",
          premiumRules: [
            {
              dayMin: "",
              dayMinIsContain: "1",
              dayMinUnit: "n",
              dayMax: "",
              dayMaxIsContain: "1",
              dayMaxUnit: "n",
              occupationLevel: '1',
            },
          ],
        },
      ];
      if (
        data.quotationItems &&
        data.quotationItems.length > 0 &&
        data.quotationItems[0].premiumRules
      ) {
        data.quotationItems[0].premiumRules.map(item => {
          item.occupationLevel = item.occupationLevel
        })
        list = data.quotationItems;
      }
      return list
    },
    tempEdit1() {
      this.setShow = true;
      this.formatMainRisk(); //主险数据处理
      this.formatOtherRisk(); //附险数据处理
      this.queryProvinces().then((res) => {
        this.formatQuoItems();
      });
    },
    formatLabelContents(obj) {
      let label = obj.labelContents;
      let arr = [];
      label.map((item, index) => {
        arr.push({
          ...item,
          key: index + 1,
        });
        item.key = index + 1;
      });
      obj.labelContents = arr;
      return obj;
    },
    //附险处理
    formatOtherRisk() {
      let data = this.quotationData.quotationCoverages;
      let otherRisk = data.filter((item) => {
        return item.riskType != 1;
      });
      console.log(otherRisk, "其他附加险");
      let otherRiskList = this.divideGroup(otherRisk, "coverageCode"); //根据coverageCode将不同附险分组
      console.log(
        otherRiskList,
        "--->附险",
        otherRiskList[0],
        otherRiskList[1]
      );
      otherRiskList.map((item) => {
        if (item[0].maxAmount) {
          console.log("1附险");
          //以下将标准附险加到列表里
          let otRisk0 = item;
          let dataSourse = this.calculDataSourse(otRisk0, 2);
          this.mainRiskList.push(dataSourse);
        } else {
          console.log("2津贴");
          //以下处理特殊附险（津贴类）
          let otRisk1 = item;
          this.chooseableRisk = [this.deelSpiaclRisk(otRisk1)];
        }
      });
      // //以下将标准附险加到列表里
      // let otRisk0 = otherRiskList[0];
      // let dataSourse = this.calculDataSourse(otRisk0, 2);
      // this.mainRiskList.push(dataSourse);

      // //以下处理特殊附险（津贴类）
      // let otRisk1 = otherRiskList[1];
      // this.chooseableRisk = [this.deelSpiaclRisk(otRisk1)];
    },
    deelSpiaclRisk(riskArr) {
      if (!riskArr || !riskArr[0]) {
        return;
      }
      let resObj = {
        coverageName: riskArr[0].coverageName,
        coverageCode: riskArr[0].coverageCode,
        calculateMethod: riskArr[0].calculateMethod,
        itemList: [],
      };
      riskArr.map((item) => {
        resObj.itemList.push({
          insuredAmount: item.insuredAmount,
          premiumRate: item.premiumRate * 100,
        });
      });
      return resObj;
    },
    divideGroup(array, key) {
      //根据某个key值分组array
      //收集key
      let result = [],
        keyArr = [],
        reciveArr = [];
      array.map((item) => {
        if (keyArr.indexOf(item[key]) == -1) {
          keyArr.push(item[key]);
        }
      });
      //筛选不同代码产品
      keyArr.map((ele) => {
        let arr = [];
        array.map((item) => {
          if (ele == item[key]) {
            arr.push(item);
          }
        });
        reciveArr.push(arr);
      });
      console.log(reciveArr, "初步分组结果集");
      reciveArr.map((item) => {
        result.push(item);
      });
      return result;
    },

    //主险处理
    formatMainRisk() {
      let data = this.quotationData.quotationCoverages; //主附险对象列表
      let mainList = [];
      let mainRiskList = []; //险别列表
      let mainRisk = data.filter((item) => {
        return item.riskType == 1;
      });
      let arrList = this.divideGroup(mainRisk, "coverageCode");
      console.log(arrList, "主险分组---------》");

      arrList.map((item) => {
        let dataSourse = this.calculDataSourse(item, 1);
        mainRiskList.push(dataSourse);
      });
      this.mainRiskList = mainRiskList;
      this.mainRisk = mainRiskList.length;
    },
    calculDataSourse(dataList, riskType) {
      console.log("一个主险的数据", dataList);
      let premiumTags = this.removeRepeat(dataList, "insuredAmount");
      const key = "coverage";
      let cols = [];
      let premium = [];
      let columns = [
        {
          title: "工程造价",
          dataIndex: "GCwide",
          width: 450,
          // fixed: "left",
          scopedSlots: { customRender: "GCwide" },
        },
      ];

      premiumTags.map((item, index) => {
        cols.push(key + index);
        columns.push({
          title: item,
          dataIndex: key + index,
          scopedSlots: { customRender: key + index },
        });
        premium.push({
          key: key + index,
          value: item,
        });
      });
      columns.push({
        title: "操作",
        dataIndex: "operation",
        width: 80,
        scopedSlots: { customRender: "operation" },
      });

      let tableData = this.calculTableData(dataList, premium);

      let result = {
        GCTable: true,
        edit: true,
        riskType: riskType,
        code: dataList[0].coverageCode,
        name: dataList[0].coverageName,
        premiumTags,
        cols,
        premium,
        columns,
        tableData,
      };
      console.log(result, "一个主险的dataSourse");
      return result;
    },
    calculTableData(dataList, premium) {
      //获取一个主险下的table数据
      //获取dataSourse中的一行数据，
      // 判断条件，1:保额列表premium，需根据保额值(10000)查找当前列徐渲染的key值(coverage0)
      //2:工程造价的范围：如1万(含)~10万（不含），minAmount,maxAmount
      let key1 = "minAmount",
        key2 = "maxAmount";
      let tableData = [];
      let divideKeys = this.divideByKeys(dataList, key1, key2); //根据minAmount和maxAmount的分组key值
      let resObj = {}; //dataSourse中的数据对象
      console.log(divideKeys, "divideKeys==>");
      divideKeys.map((item, idx) => {
        resObj = {
          GCwide: this.objToDisplay(item),
          key: idx,
          editable: true,
          wideObj: {
            maxAmount: item.maxAmount / 10000,
            maxIsContain: item.maxIsContain,
            minAmount: item.minAmount / 10000,
            minIsContain: item.minIsContain,
          },
        };

        dataList.map((obj) => {
          if (obj[key1] == item[key1] && obj[key2] == item[key2]) {
            let cell = this.getCell(obj, premium);
            resObj[cell.key] = cell.value;
          }
        });
        tableData.push(resObj);
        // console.log(resObj, "dataSourse中一行数据");
      });

      return tableData;
    },
    getCell(obj, premium) {
      //根据工程造价和保额查询一个表格td的值
      let exit = premium.find((item, index) => {
        return item.value == obj.insuredAmount;
      });
      let res = {
        key: exit.key,
        value: obj.premiumRate,
      };
      return res;
    },
    divideByKeys(dataList, key1, key2) {
      //根据多个key值将数组分类
      let arr = [];
      dataList.map((item) => {
        let isExit = false;
        arr.map((obj) => {
          if (obj[key1] == item[key1] && obj[key2] == item[key2]) {
            isExit = true;
          }
        });
        if (!isExit) {
          arr.push({
            [key1]: item[key1],
            [key2]: item[key2],
            minIsContain: item.minIsContain,
            maxIsContain: item.maxIsContain,
          });
        }
      });
      return arr;
    },
    removeRepeat(array, key) {
      let keyArr = [];
      array.map((item) => {
        if (keyArr.indexOf(item[key]) == -1) {
          keyArr.push(item[key]);
        }
      });
      return keyArr;
    },

    formatQuoItems() {
      //处理其他费率调整系数
      const items = this.quotationData.quotationItems;
      let arr = []; //通用部分
      items.map((item) => {
        if (this.itemTypeList.indexOf(item.itemType) > -1) {
          let ruleArr = item.premiumRules;
          if (!item.premiumRules) {
            ruleArr = [];
          }
          arr.push({
            ...item,
            premiumRules: ruleArr,
          });
        }
      });

      let areaObj = items.find((item) => {
        return item.itemType == "PROJECT_ADDRESS";
      });
      let areaArr = []; //地区部分
      if (areaObj && areaObj.premiumRules) {
        areaObj.premiumRules.map((item) => {
          areaArr.push({
            ...item,
            province: this.province,
          });
        });
      }

      let dateObj = items.find((item) => {
        return item.itemType == "POLICY_DAYS";
      });

      let commission = {
        itemName: "佣金比例",
        itemType: "COMMISSION_RATE",
        premiumRules: [],
      };
      let exit1 = items.find((item) => {
        return item.itemType == "COMMISSION_RATE";
      });
      if (exit1 && exit1.premiumRules) {
        commission = exit1;
      }

      let countObj = {
        itemName: "投保份数",
        itemType: "INSURED_COUNT",
        premiumRules: [
          {
            calculateMethod: "1",
            singlePremium: 1,
          },
        ],
      };
      let exit2 = items.find((item) => {
        return item.itemType == "INSURED_COUNT";
      });
      if (exit2) {
        countObj = exit2;
      }

      //免赔额
      let deductible = {
        itemName: "免赔额系数",
        itemType: "DEDUCTIBLE_RATE",
        premiumRules: [
          {
            optinonName: "",
            optinonValue: "",
            calculateMethod: "1",
            singlePremium: "",
          },
        ],
      };
      let exit3 = items.find((item) => {
        return item.itemType == "DEDUCTIBLE_RATE";
      });
      if (exit3 && exit3.premiumRules) {
        deductible = exit3;
      }

      let obj = {
        list: arr,
        areaObj: {
          ...areaObj,
          premiumRules: areaArr,
        },
        dateObj,
        commission, //<!-- i云保暂不上线TODO:测试开放 -->
        countObj,
        deductible,
      };
      this.otherRiskInit = obj;
      console.log(obj, "obj================");
      this.showOtherRisk = true;
    },
    queryProvinces() {
      return api.queryProvinces().then((res) => {
        this.province = res.data;
      });
    },
    // 编辑  ---》end
    addData(item, index) {
      let chooseableRisk = [...this.chooseableRisk];
      chooseableRisk[index].itemList.push({
        itemName: "",
        itemRate: "",
        itemCode: "",
      });
      this.chooseableRisk = [...chooseableRisk];
    },
    deleteData(item, index, ele, idx) {
      let chooseableRisk = [...this.chooseableRisk];
      chooseableRisk[index].itemList.splice(idx, 1);
      this.chooseableRisk = [...chooseableRisk];
    },

    toggleRiskBg() {
      let exit = this.mainRiskList.find((item) => {
        return item.riskType == 1;
      });
      if (exit && this.riskType == 1) {
        this.$notification.warning({ message: "主险已存在" });
        return;
      }
      this.mainRisk++;
      this.mainRiskList.push({
        edit: true, // 名称的编辑
        riskType: this.riskType, //主附险 "0"-主险，"1"-附险
        name: "险别名称",
        GCTable: false, //是否展示table
        code: "RISK_" + this.mainRisk, //险种代码
        mainRisk: this.mainRisk,
        premiumTags: [], //保费列表
        columns: [
          //默认数据
          {
            title: "工程造价",
            dataIndex: "GCwide",
            width: 450,
            fixed: "left",
            scopedSlots: { customRender: "GCwide" },
          },
        ],
        tableData: [
          //默认数据
          {
            key: "0",
            GCwide: "10万(不含)-100万(含)",
            wideObj: {
              minAmount: 10,
              minIsContain: "0",
              maxAmount: 100,
              maxIsContain: "1",
            },
          },
          {
            key: "1",
            GCwide: "100万（不含）-500万（含）",
            wideObj: {
              minAmount: 100,
              minIsContain: "0",
              maxAmount: 500,
              maxIsContain: "1",
            },
          },
          {
            key: "2",
            GCwide: "500万（不含）-1000万（含）",
            wideObj: {
              minAmount: 500,
              minIsContain: "0",
              maxAmount: 1000,
              maxIsContain: "1",
            },
          },
          {
            key: "3",
            GCwide: "1000万（不含）-10000万（含）",
            wideObj: {
              minAmount: 1000,
              minIsContain: "0",
              maxAmount: 10000,
              maxIsContain: "1",
            },
          },
        ],
      });
      console.log(this.mainRiskList);
    },
    deleteOne(index) {
      console.log(index, "删除");
      let mainRiskList = this.mainRiskList;
      mainRiskList.splice(index, 1);
      this.mainRiskList = [...mainRiskList];
    },
    riskListChange(option) {
      let mainRiskList = [...this.mainRiskList];
      mainRiskList.map((ele, index) => {
        if (option.listIndex == index) {
          ele = option.list;
        }
      });
      this.mainRiskList = [...mainRiskList];
      console.log(this.mainRiskList, "所有数据");
    },
    configChange(option) {
      option.quotationInfo.templateCode = this.templateCode;
      this.baseData = option;
      console.log(option, "基础数据");
    },
    formatParams() {
      let mainRiskList = this.mainRiskList;
      let quotationCoverages = []; //报价书险别信息对象
      let quotationCoverageItems = []; //报价书险别条目信息对象
      mainRiskList.map((option, index) => {
        quotationCoverageItems.push({
          coverageName: option.name,
          coverageCode: option.code,
          riskType: option.riskType,
        });
        let result = this.deelCoverage(option);
        console.log(quotationCoverages, "测试", result);
        quotationCoverages = quotationCoverages.concat(result);
      });
      console.log(quotationCoverages, "测试");
      return {
        quotationCoverages,
        quotationCoverageItems,
      };
    },
    deelCoverage(option) {
      let obj = {},
        list = [];
      option.premium.map((ele) => {
        option.tableData.map((item) => {
          if (item[ele.key]) {
            obj = {
              coverageName: option.name,
              coverageCode: option.code,
              riskType: option.riskType,
              minAmount: item.wideObj.minAmount * 10000,
              minIsContain: item.wideObj.minIsContain,
              maxAmount: item.wideObj.maxAmount * 10000,
              maxIsContain: item.wideObj.maxIsContain,
              premiumRate: item[ele.key], //费率
              insuredAmount: ele.value, //保额
              calculateMethod: 1, //0按固定保费/1按保额费率/2按总保费费率/3按指定条目值*费率
            };
            list.push(obj);
          }
        });
      });
      return list;
    },
    otherRiskChange(option) {
      console.log(option, "--->其他调整系数");
      this.otherRiskInfo = option;
    },
    formatChooseableRisk() {
      let quotationCoverages = [];
      let quotationCoverageItems = [];
      this.chooseableRisk.map((item) => {
        item.itemList.map((ele) => {
          quotationCoverages.push({
            calculateMethod: item.calculateMethod,
            coverageCode: item.coverageCode,
            coverageName: item.coverageName,
            premiumRate: ele.premiumRate / 100,
            insuredAmount: ele.insuredAmount,
            riskType: 2,
          });
          quotationCoverageItems.push({
            coverageCode: item.coverageCode,
            coverageName: item.coverageName,
            riskType: 2,
          });
        });
      });
      return {
        quotationCoverages,
        quotationCoverageItems,
      };
    },
    templateSave1() {
      //建工模板
      if (!this.baseData.labelContents) {
        this.$notification.warning({ message: `请先保存基础数据` });
        return;
      }
      if (this.otherRiskInfo.length == 0) {
        this.$notification.warning({ message: `请先保存其他调整系数数据` });
        return;
      }

      let chooseableRisk = this.formatChooseableRisk();
      let result;
      try {
        result = this.formatParams();
      } catch (error) {
        this.$notification.warning({ message: "请配置险别信息" });
        return;
      }

      console.log("保存时", this.baseData, "基础信息");
      console.log("保存时", result, "主附险信息");
      console.log("保存时", this.otherRiskInfo, "--->其他调整系数");
      console.log("保存时", chooseableRisk, "-->其他可选附加选");

      let quotation = {
        quotationCoverages: result.quotationCoverages.concat(
          chooseableRisk.quotationCoverages
        ),
        quotationCoverageItems: result.quotationCoverageItems.concat(
          chooseableRisk.quotationCoverageItems
        ),
      };
      console.log(quotation, "合并后");
      let data = {
        ...this.baseData,
        ...quotation,
        quotationItems: this.otherRiskInfo,
        uStr: this.uStr,
      };
      if (this.$route.name == "edit") {
        data.quotationInfo.id = this.tampId;
      }
      api.saveOrUpdate(data).then((res) => {
        this.$notification.success({ message: `保存成功` });
        this.templateId = res.data.msg;
        // this.link =
        //   window.location.origin + "/pcmall/BJQ/mindex?id=" + this.templateId + '&uStr='+this.uStr;
        // this.openUrl(this.link);
        this.$router.push({ name: "list", query: { uStr: this.uStr } });
      });
    },
    openUrl(url) {
      const opener = window.open("_blank");
      opener.location.href = url;
    },
    formatPlanList() {
      //获取1类下的6个计划，4,5类可能只有4中计划
      let list = this.childInfo.quotationCoverageList;
      let planList = list[0].list[0].planList;
      let leng = planList.length;
      for (let i in list) {
        let array;
        if (list[i].list[0]) {
          array = list[i].list[0].planList;
          if (array.length > leng) {
            leng = array.length;
            planList = array;
          }
        }
      }

      return planList;
    },
    templateSave2() {
      //团意-OPA
      if (!this.baseData.labelContents) {
        this.$notification.warning({ message: `请先保存基础数据` });
        return;
      }
      let data = {
        ...this.baseData,
        quotationCoverageList: this.formarCoverList(),
        quotationPlans: this.formatPlanList(),
        quotationItems: this.childInfo.quotationItems,
        uStr: this.uStr,
      };
      if (this.$route.name == "edit") {
        data.quotationInfo.id = this.tampId;
      }
      api.saveOrUpdate(data).then((res) => {
        this.$notification.success({ message: `保存成功` });
        this.templateId = res.data.msg;
        // this.link =
        //   window.location.origin + "/pcmall/BJQ/mindex?id=" + this.templateId + '&uStr='+this.uStr;
        // this.openUrl(this.link);
        this.$router.push({ name: "list", query: { uStr: this.uStr } });
      });
    },
    formarCoverList() {
      //处理数据quotationCoverageList
      let list = this.childInfo.quotationCoverageList;
      let arr = [];
      list.map((item) => {
        if (item.list.length > 0) {
          arr.push(item);
        }
      });
      return arr;
    },
    handleSave() {
      if (this.templateCode == "001") {
        this.templateSave1();
      } else {
        this.templateSave2();
      }
    },
    //建工模板end
  },
};
</script>

<style lang="scss" scoped>
.page_ {
  padding: 30px;
  padding-bottom: 100px;
  width: 80%;
  margin: 0 auto;
  .title_ {
    clear: both;
    margin: 30px 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .cutleft_ {
      font-size: 16px;
      font-family: Microsoft YaHei UI;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      // width: 10%;
    }
    .cutoff_ {
      // width:90%;
      flex: 1;
      height: 5px;
      background: #f0f0f0;
    }
  }
  .right_ {
    text-align: center;
    margin: 30px 0;
  }
}

.risk_ {
  padding-bottom: 50px;
}
.title_ {
  margin: 30px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  .cutoff_ {
    // width:90%;
    flex: 1;
    height: 5px;
    background: #f0f0f0;
  }
}
.icon_ {
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    color: red;
  }
}
.wid_150 {
  width: 150px;
  margin: 10px;
}
.wid_100 {
  width: 100px;
  margin: 10px;
}
.flex_ {
  display: flex;
  align-items: center;
  label {
    font-weight: bold;
  }
}
</style>